import { createAction } from "redux-actions";

export const DASHBOARDCOUNT = "DASHBOARDCOUNT";
export const dashboardCount = createAction(DASHBOARDCOUNT);

export const DASHBOARDORDERSTATS = "DASHBOARDORDERSTATS";
export const dashboardOrderStats = createAction(DASHBOARDORDERSTATS);

export const AFFILIATEDASHBOARDCOUNT = "AFFILIATEDASHBOARDCOUNT";
export const affiliateDashboardCount = createAction(AFFILIATEDASHBOARDCOUNT);
